import { LocationModel } from '../types';

/**
 * Gets Location name
 * Returns a Location Name as a string
 */
export const getLocationName = (location: LocationModel, shorten = false): string => {
  const shortName = location?.names?.short?.length ? location.names.short[0] : '';
  const longName = location?.names?.long?.length ? location.names.long[0] : '';
  const name = shortName || longName;

  if (name && shorten) {
    return shortenLocationName(name);
  }
  return name;
};

const shortenLocationName = (name: string): string => {
  const parts = name.split('International');
  if (parts.length === 1) {
    const moreParts = name.split('Airport');
    return moreParts[0];
  }
  return parts[0];
};
